import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './ExpensesPage.css';
import { 
  accountService, 
  receiptService 
} from '../../../apiServices';
import { useRefresh } from '../../../contexts/RefreshContext';
import { 
  Account, 
  CreateReceiptRequest
} from '../../../apiServices/types';
import { toLocalDateString, toLocalISOString, toUTCDateString } from '../../../utils';
import {
  CreateListForm,
  CreateListFormRef
} from './components';

const ExpensesPage: React.FC = () => {
  const navigate = useNavigate();
  const [accounts, setAccounts] = useState<Account[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>('');
  const createListFormRef = useRef<CreateListFormRef>(null);

  useEffect(() => {
    loadAccounts();
  }, []);

  const loadAccounts = async (): Promise<void> => {
    try {
      setLoading(true);
      const data = await accountService.getAll();
      setAccounts(data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = useCallback(async () => {
    await loadAccounts();
  }, []);

  useRefresh(handleRefresh);

  const createShoppingList = async (listName: string, selectedAccountId: string, date?: string): Promise<void> => {
    if (!listName || !selectedAccountId) return;

    setIsLoading(true);
    setError('');

    try {
      let dateWithTime: string | undefined = undefined;
      if (date) {
        const now = new Date();
        const todayStr = toLocalDateString(now);
        dateWithTime = date === todayStr ? toLocalISOString(now) : toUTCDateString(date);
      }

      const receiptData: CreateReceiptRequest = {
        name: listName,
        accountId: selectedAccountId,
        type: 0,
        date: dateWithTime
      };

      const receipt = await receiptService.create(receiptData);

      createListFormRef.current?.reset();
      
      navigate(`/dashboard/expenses/${receipt.id}`);
    } catch (error) {
      setError('Помилка створення списку: ' + (error as Error).message);
    } finally {
      setIsLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="expenses-page">
        <div className="card">
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>Завантаження витрат...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="expenses-page">
      <CreateListForm
        ref={createListFormRef}
        accounts={accounts}
        isLoading={isLoading}
        error={error}
        onSubmit={createShoppingList}
      />
    </div>
  );
};

export default ExpensesPage;
